import React from 'react';

const DeviceSupportsESIM = (props) => {
  return <div className='device-supports-eSIM-popup'>DeviceSupportsESIM popup content</div>;
};

export default DeviceSupportsESIM;
